var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.svg)},on:{"click":function($event){return _vm.click($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }